import Vue from 'vue'
import service from '../services/warehouseRangesService.js'

export function useRanges() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getRanges(params = {}) {
    state.loading = true
    try {
      const response = await service.getRanges(params)
      state.items = response.current_page === 1
        ? [...response.data]
        : [...state.items, ...response.data]
      state.currentPage = response.current_page
      state.lastPage = response.last_page
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function addRange(payload) {
    state.loading = true
    try {
      const response = await service.addRange(payload)
      state.items.push(response.new_range)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function updateRange(payload) {
    state.loading = true
    try {
      const response = await service.updateRange(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function deleteRange(payload) {
    state.loading = true
    try {
      const response = await service.deleteRange(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getRanges,addRange, updateRange, deleteRange }
}
